module.exports = __webpack_public_path__ + "static/img/logo.396e867.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo.gif
// module id = BhpG
// module chunks = 28